// extracted by mini-css-extract-plugin
module.exports = {"tos":"Tos_tos__aZQhs","tosContainer":"Tos_tosContainer__1whkK","tosSectionOne":"Tos_tosSectionOne__2PPqy"};